import {Injectable} from "@angular/core";
import gql from "graphql-tag";
import {VisbosService} from "../graphql/visbos.service";
import {Country} from "../model/country.type";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {City} from "../model/city.type";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {map} from "rxjs/operators";

export const addressFragments = {
  country: gql`
    fragment CountryFields on Country {
      cuid, label, is_editable
      name, short_name
    }`,
  address: gql`
    fragment AddressFields on Address {
      cuid, address_name, is_editable
      street, number,
      city {
        cuid, zip, town,
        country { cuid, label, name, short_name }
      }
    }`,
  city: gql`
    fragment CityFields on City {
      cuid, zip, town, is_editable
      country { cuid, label, name, short_name }
    }`
};

export const fetchCountriesQuery = gql`
  query FetchCountriesQuery($searchString: String) {
    countries(search_string: $searchString) {
      ...CountryFields
    }
  }

  ${addressFragments['country']}
`;

@Injectable()
export class AddressService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getCities(searchString?: string): ApolloQueryObservable<City[]> {

    let query = this.fetchItems<City[]>({
      query: gql`query FetchCities($searchString: String) {
        cities(search_string: $searchString) {
          ...CityFields
        }
      }

      ${addressFragments['city']}
      `,
      variables: {
        searchString: searchString
      }
    });

    return <ApolloQueryObservable<City[]>>query.pipe(map(({data}: any) => data.cities));
  }

  public getCountries(searchString?: string): ApolloQueryObservable<Country[]> {

    let query = this.fetchItems<Country[]>({
      query: fetchCountriesQuery,
      variables: {
        searchString: searchString
      },
    });

    return <ApolloQueryObservable<Country[]>>query.pipe(map(({data}: any) => data.countries));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/services/address.service.ts